export class AzureSearchConfig {
    public endpoint: string;
    public queryKey: string;
    public isProduction: boolean;

    constructor(data: { endpoint: string; queryKey: string; isProduction: boolean }) {
        this.endpoint = data.endpoint;
        this.queryKey = data.queryKey;
        this.isProduction = data.isProduction;
    }
}
